import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "text-danger-dark mt-4 flex items-center space-x-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "error_outline", -1)
const _hoisted_4 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarInput = _resolveComponent("CalendarInput")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      loading: _ctx.loading,
      noText: _ctx.$t('dialog.default_cancel_text'),
      yesText: _ctx.$t('course_tree.schedule_label'),
      showDialog: _ctx.visible,
      disableOk: _ctx.invalid,
      onYes: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onYes())),
      onNo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNo()))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("course_tree.select_schedule_datetime")), 1),
          _createVNode(_component_CalendarInput, {
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("course_tree.schedule_datetime")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.showErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("course_tree.invalid_schedule_time")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["loading", "noText", "yesText", "showDialog", "disableOk"])
  ]))
}